<template lang="html">

  <section class="interface_labels">
    <div class="row">
      <div class="col-lg-12 grid-margin stretch-card">
        <div class="card">
          <b-collapse id="interface_labels_filters" class="mt-2 ml-4 mr-4">
            <b-card>
              <p class="card-text">Filters</p>
                <div class="row mb-2">
                  <div class="col-lg-2">Code:</div>
                  <input type="text" class="col-lg-4" v-model="codeFilter" placeholder="Code" />
                  <div class="col-lg-2">Label:</div>
                  <input type="text" class="col-lg-4" v-model="labelFilter" placeholder="Label" />
                </div> 
                <div class="row mb-2">
                  <div class="col-lg-2">Label Group:</div>
                  <div class="col-lg-4">
                    <b-form-select v-model="labelGroupFilter">
                      <b-form-select-option :value="null">ALL</b-form-select-option>
                      <b-form-select-option v-for="group in labelGroupList" :key="group" :value="group">
                        {{ group }}
                      </b-form-select-option>
                    </b-form-select>
                  </div>
                </div>
              <b-button variant="primary" v-b-toggle.interface_labels_filters @click="search()"><i class="mdi mdi-magnify"></i>Search</b-button>
            </b-card>
          </b-collapse>
          <div class="col-lg-12 card-body row">
            <div class="col-lg-12">
              <h4 class="card-title">Interface Labels</h4>
              <p class="card-description">
                {{getLanguageLabel}}
              </p>
            </div>
            <div class="col-lg-4">             
              <div class="col-lg-12 row">
                <b-pagination
                   align="fill"
                  limit="6"
                  v-model="currentPage"
                  :total-rows="totalRowsResult"
                  :per-page="perPage"
                  first-text="<<"
                  prev-text="<"
                  next-text=">"
                  last-text=">>"
                  ellipsisText="..."
                  aria-controls=""
                  class="col-lg-10"
                ></b-pagination>               
              </div>
            </div>
            <div class="col-lg-1">
                <b-form-select id="perPage-dd" v-model="perPage" class="col-lg-12">
                 <b-form-select-option value="5">5</b-form-select-option>
                  <b-form-select-option value="10">10</b-form-select-option>
                  <b-form-select-option value="20">20</b-form-select-option>
                  <b-form-select-option value="50">50</b-form-select-option>
                  <b-form-select-option value="100">100</b-form-select-option>
                </b-form-select>
            </div>
            <div class="col-lg-7">
              <!-- campo usato per fare prove upload -->
              <!-- <input  type="file" id="file-input" multiple > -->
              <span class="float-right">
                <b-button variant="primary mr-1" v-b-toggle.interface_labels_filters><i class="mdi mdi-filter"></i></b-button>
                <b-button variant="primary mr-1" @click="refreshTable"><i class="mdi mdi-refresh"></i>Refresh Table</b-button>
                <b-button variant="primary mr-1" v-b-modal.modal-new-int-lab @click="btnNew"><i class="mdi mdi-plus"></i>New</b-button>
                <b-button variant="primary mr-1" v-b-modal.modal-export><i class="mdi mdi-file-export"></i>Export</b-button>
                <b-button variant="primary" v-b-modal.modal-import><i class="mdi mdi-file-import"></i>Import</b-button>
              </span>
            </div>
            <b-table ref="interface_labels_tab"
              id="table" 
              striped 
              hover 
              responsive 
              :items="items" 
              :fields="fields"
              :per-page="perPage"
              :current-page="1"
              primary-key="id"
              no-local-sorting
              no-provider-paging
              sort-icon-left
            >
              <!-- A custom formatted column -->
              <template v-slot:cell(buttons)="data" lang="html">
                <b-row>
                  <b-button class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary" v-b-modal.modal-edit @click="curItem=data.item">
                    <i class="mdi mdi-pencil"></i>
                  </b-button>
                  <b-button class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="danger" @click="deleteItem(data.item)">
                    <i class="mdi mdi-delete"></i>
                  </b-button>
                </b-row>
              </template>
            </b-table>
            <b-modal id="modal-edit" title="Edit" v-if="curItem" size="lg" header-bg-variant="primary" header-text-variant="light" centered>
              <b-container fluid>
                <b-row>
                  <div class="col-lg-3">Code*:</div><input type="text" class="col-lg-3" placeholder="Code" v-model="curItem.code" disabled/>
                  <div class="col-lg-3">Label*:</div><input type="text" class="col-lg-3" placeholder="Label" v-model="curItem.label"/>
                </b-row>
                <hr>
                <b-row>
                  <div class="col-lg-3">Model Enabled (regexp):</div><input type="text" class="col-lg-3" placeholder="Model Enabled (regexp)" v-model="curItem.modelEnableRegexp" disabled/>
                  <div class="col-lg-3">Model Disabled (regexp):</div><input type="text" class="col-lg-3" placeholder="Model Disabled (regexp)" v-model="curItem.modelDisableRegexp" disabled/>
                </b-row>
              </b-container>
              <template v-slot:modal-footer="{ cancel, ok }" lang="html">
                <fragment><!-- serve semplicemente ad evitare di avere l'errore per cui Vue si lamenta che un template deve avere un solo figlio -->
                  <b-button variant="secondary" @click="cancel()">
                    Annulla
                  </b-button>
                  <b-button variant="primary" @click="saveCurItem(curItem)">
                    Salva
                  </b-button>
                </fragment>
              </template>
            </b-modal>
             <b-modal id="modal-new-int-lab" title="New Interface Label"  size="lg" header-bg-variant="primary" header-text-variant="light" centered>
              <b-container fluid>
                <b-row>
                  <div class="col-lg-3">Label Group:</div>
                  <b-form-select id="labelGroup-dd" v-model="newItem.labelGroup" class="col-lg-3">
                    <b-form-select-option v-for="lg in labelGroupList" :key="lg" :value="lg">{{lg}}</b-form-select-option>
                  </b-form-select>
                </b-row>
                <hr>
                  <b-row>
                  <div class="col-lg-3">Code*:</div><input type="text" class="col-lg-3" placeholder="Code" v-model="newItem.code"/>
                  <div class="col-lg-3">Label*:</div><input type="text" class="col-lg-3" placeholder="Label" v-model="newItem.label"/>
                </b-row>
                <hr>
                <b-row>
                  <div class="col-lg-3">Model Enabled (regexp):</div><input type="text" class="col-lg-3" placeholder="Model Enabled (regexp)" v-model="newItem.modelEnableRegexp"/>
                  <div class="col-lg-3">Model Disabled (regexp):</div><input type="text" class="col-lg-3" placeholder="Model Disabled (regexp)" v-model="newItem.modelDisableRegexp"/>
                </b-row>
              </b-container>
              <template v-slot:modal-footer="{ cancel, ok }" lang="html">
                <fragment><!-- serve semplicemente ad evitare di avere l'errore per cui Vue si lamenta che un template deve avere un solo figlio -->
                  <b-button variant="secondary" @click="cancel()">
                    Annulla
                  </b-button>
                  <b-button variant="primary" @click="createItem()">
                    Salva
                  </b-button>
                </fragment>
              </template>
            </b-modal>
             <b-modal id="modal-export" title="Export" @hidden="resetExportModal" size="lg" header-bg-variant="primary" header-text-variant="light" centered>
              <b-container fluid class="export-modal-body">
                <div class="export-section">
                  <div class="export-section-title" style="margin-bottom: 6px;">Languages</div>
                    <div class="export-section-subtitle" style="margin-bottom: 12px;">
                      Select one or more languages to include in the export.
                    </div>

                  <multi-select
                    id="languages"
                    :options="languageOptions"
                    :selected-options="selectedLanguagesToExport"
                    placeholder="Select languages"
                    @select="onSelectLanguagesToExport">
                  </multi-select>
                </div>

                <div class="export-checkbox-box">
                  <b-form-checkbox v-model="exportFiltered" style="margin-bottom: 6px;">
                    Export filtered records
                  </b-form-checkbox>

                  <div class="export-section-subtitle checkbox-subtitle">
                    Export only the records currently filtered in the table.
                  </div>
                </div>
              </b-container>

              <template v-slot:modal-footer="{ cancel, ok }" lang="html">
                <fragment>
                  <b-button variant="secondary" @click="cancel()">
                    Annulla
                  </b-button>

                  <b-button
                    variant="primary"
                    @click="newItem.scope='MKTG'; urlExport='toXlsx'; export_Xlsx_Csv(newItem)">
                    Export xlsx
                  </b-button>
                </fragment>
              </template>
            </b-modal>
            <b-modal id="modal-import" title="Upload File" @hidden="resetImportModal" size="lg" header-bg-variant="primary" header-text-variant="light" centered>
              <div class='modal-body'>
                <!-- Form -->
                <form method='post' action='' enctype='multipart/form-data'>
                <div class='custom-file mb-3'>
                <input type='file' class='custom-file-input' id='file-input' name='filename' @change="changeFileName()">
                <label class='custom-file-label' for='file-input'>{{fileName}}</label>
                </div>
                <br>
                </form>
                <!-- Preview-->
                <div id='preview'></div>
              </div>
              <template v-slot:modal-footer="{ cancel, ok }" lang="html">
                <fragment><!-- serve semplicemente ad evitare di avere l'errore per cui Vue si lamenta che un template deve avere un solo figlio -->
                  <b-button variant="secondary" @click="cancel()">
                    Annulla
                  </b-button>
                  <b-button variant="primary" @click="uploadFile()">
                    Upload
                  </b-button>
                </fragment>
              </template>
            </b-modal>
            
          </div>
        </div>
      </div>
    </div>
  </section>

</template>
<style>
  .interface_labels table td,
  .interface_labels table th {
    text-align: left !important;
    vertical-align: top !important;
  }

  li.nav-item.active > a {
    color: #fff!important;
    text-shadow: 2px 2px 4px rgba(100,100,100,0.5);
  }
</style>
<script lang="js">
import { mapState, mapActions, mapGetters } from "vuex";
import FileDownload from 'js-file-download'
import { MultiSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'
export default {
  name: 'interface_labels',
  components: {
    MultiSelect
  },
  methods: {
      onSelectLanguagesToExport(items){
      if(items && items.length && items[items.length - 1].value == 'ALL'){
        this.selectedLanguagesToExport = this.languages;
        this.newItem.languageToExport = this.languages.map(function(lg){
          return lg.value;
        });
      } else {
        this.selectedLanguagesToExport = items;
        this.newItem.languageToExport = items.map(function(lg){
          return lg.value;
        });
      }
    },
    export_Xlsx_Csv(data){
      this.setSpinnerStatus(true);
      this.axios
      .get('/ccb/auth/fe/interfaceLabel/' + this.urlExport, {
        params: {
          scope: data.scope,
          languageToExport: data.languageToExport.join(','),
          allLanguagesExport: this.selectedLanguagesToExport.length === this.languages.length,
          exportFiltered: this.exportFiltered,
          code: this.codeFilter,
          label: this.labelFilter,
          labelGroup: this.labelGroupFilter
        },
        responseType: 'blob',
        ...this.authHeader
      })
      .then((response) => {
        var disposition = response.headers['content-disposition'];
        var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        var matches = filenameRegex.exec(disposition);
        var filename = matches[1].replace(/['"]/g, '');
        FileDownload(response.data, filename);
      })
      .catch(error => {
        this.$bvModal.msgBoxOk(error.message, {
          okVariant: 'danger',
          hideHeaderClose: false,
          centered: true
        })
      }).finally(e=>{
        this.setSpinnerStatus(false);
        this.$bvModal.hide('modal-export');
      })
    },
    uploadFile(){
      let file=document.querySelector('#file-input').files[0];   
      let formData = new FormData();
      formData.append("file", file );
      formData.append("filename", file.name );
       this.setSpinnerStatus(true);
       this.axios
       .post("/ccb/auth/fe/interfaceLabel/fromXlsx", formData ,  this.authHeader)
       .then((response) => {
          var result = "";

          response.data.forEach(element => {
            result += element + " \n \n";
          });

          const messageNodes = this.$createElement(
            'pre',
            {
              style: {
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
                overflowX: 'hidden',
                maxWidth: '100%'
              },
              domProps: {
                innerHTML: result
              }
            }
          );

          this.$bvModal.msgBoxOk([messageNodes], {
            okVariant: 'success',
            hideHeaderClose: false,
            centered: true,
            size: 'xl'
          }).then(value => {
            this.refreshTable();
          });
        })
       .catch(error => {
         this.$bvModal.msgBoxOk(error.message, {
           okVariant: 'danger',
           hideHeaderClose: false,
           centered: true
         })
       }).finally(e=>{
         this.setSpinnerStatus(false);
         this.$bvModal.hide('modal-import');
       })
    },
    changeFileName(){
      if(document.querySelector('#file-input').files[0] && document.querySelector('#file-input').files[0].name) {
        this.fileName = document.querySelector('#file-input').files[0].name;
      } else 
      {
        this.fileName = '';
      }

    },
    resetExportModal(){
          this.newItem.languageToExport = [this.getCurLanguage];
          this.selectedLanguagesToExport = this.languages.filter(lg => lg.value == this.getCurLanguage);
          this.exportFiltered = true;
        },
        resetImportModal(){
      this.fileName = '';

      const input = document.querySelector('#file-input');

      if(input){
        input.value = '';
      }
    },
    deleteItem(item) {
      this.$bvModal.msgBoxConfirm('Vuoi veramente cancellare '+item.code+'?', {
        title: 'Elimina',
        okVariant: 'danger',
        okTitle: 'Elimina',
        cancelTitle: 'Annulla',
        hideHeaderClose: false,
        centered: true
      })
      .then(value => {
            if (value){
               this.setSpinnerStatus(true);
                this.axios
                .delete('/ccb/auth/fe/interfaceLabel/' + item.id ,this.authHeader)
                .then(response => {
                  this.setSpinnerStatus(false);
                  this.$bvModal.msgBoxOk(response.data.message, {
                    okVariant: 'success',
                    hideHeaderClose: false,
                    centered: true
                  })
                  .then(value => {
                    this.refreshTable();
                    this.curItem=null;
                  })
                })
                .catch(error => {
                  this.$bvModal.msgBoxOk(error.message, {
                    okVariant: 'danger',
                    hideHeaderClose: false,
                    centered: true
                })
                }).finally(e=>{
                  this.setSpinnerStatus(false);
                })  
            }
        })

    },
    saveCurItem(curItem) {
    window.curr = curItem
    this.setSpinnerStatus(true);
     var intLabObj = 
     {
        id:  curItem.id,
        code:  curItem.code,
        label:  curItem.label,
        labelGroup:  curItem.labelGroup,
        language:  curItem.language,
        modelEnableRegexp:curItem.modelEnableRegexp,
        modelDisableRegexp: curItem.modelDisableRegexp
      }
      
    this.axios
        .put('/ccb/auth/fe/interfaceLabel/' + curItem.id, intLabObj ,this.authHeader)
        .then(response => {
          if(response.status == 200) {  
            this.$bvModal.msgBoxOk(response.data.message, {
            okVariant: 'success',
            hideHeaderClose: false,
            centered: true
            })
            .then(value => {
            this.refreshTable();
            })
          }
        })
        .catch(error => {
          this.$bvModal.msgBoxOk(error.message, {
            okVariant: 'danger',
            hideHeaderClose: false,
            centered: true
          })
        }).finally(e=>{
          this.setSpinnerStatus(false);
          this.$bvModal.hide('modal-edit');
        })
    },
    createItem() {
    var intLabObj = this.newItem     
    if((intLabObj.code==null || intLabObj.label==null) || (intLabObj.code.trim()=="" || intLabObj.label.trim()=="")) {
       this.$bvModal.msgBoxOk("Inserisci tutti i campi obbligatori", {
        okVariant: 'danger',
        hideHeaderClose: false,
        centered: true
      })
    }else{
      this.setSpinnerStatus(true);
      intLabObj.language = {id: this.getCurLanguageObj.id}
      this.axios
          .post('/ccb/auth/fe/interfaceLabel', intLabObj, this.authHeader)
            .then(response => {
              if(response.status == 200) {
              this.$bvModal.msgBoxOk(response.data.message, {
                okVariant: 'success',
                hideHeaderClose: false,
                centered: true
              })
              .then(value => {
                this.refreshTable();
              })
              }
            })
            .catch(error => {
              this.$bvModal.msgBoxOk(error.message, {
                okVariant: 'danger',
                hideHeaderClose: false,
                centered: true
              })
              // place the loginError state into our vuex store
            }).finally(e=>{
              this.setSpinnerStatus(false);
              this.$bvModal.hide('modal-new-int-lab');
            })
      }
    },
    search() {
      this.setLastSearch(this.search) 
      this.setSpinnerStatus(true);
      var params = {
            labelGroup: this.labelGroupFilter, modelName: this.getCurModel, language: this.getCurLanguage, 
           page: this.currentPage - 1, size: this.perPage, sortBy: this.sortBy, sortDesc: this.sortDesc, 
            label: this.labelFilter, code: this.codeFilter }
      
      this.axios
      .get('/ccb/auth/fe/interfaceLabel/findAllByGroupPaged' ,  {
        params: params,
        ...this.authHeader}          
          )
          .then((response) => {
          this.setSpinnerStatus(false);
          this.setInterfaceLabels(response.data.content)
          this.totalRowsResult=this.totalRowsResult=response.data.totalElements;           
          });
    },
    btnNew() {
      setTimeout(() => {
        var atG = this.getCurLabelGroup
        //document.querySelector('#labelGroup-dd').querySelector('option[value="'+atG+'"]').selected = true  
        this.newItem.labelGroup = this.getCurLabelGroup;
      }, 500);
        //  this.axios
        //    .get('/ccb/auth/fe/editorialPlaceholder/toXlsx' ,  {
        //      responseType: 'blob',
        //     ...this.authHeader,
        //        params:data}
        //        )
        //                      .then((response) => {
        //             var disposition = response.headers['content-disposition'];
        //             var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        //             var matches = filenameRegex.exec(disposition);
        //             var filename = matches[1].replace(/['"]/g, '');
        //            FileDownload(response.data, filename);
        //           });

        //chiamata per metodi di import file 
  // let file=document.querySelector('#file-input').files[0];

     
  //   let formData = new FormData();
  //   formData.append("file", file, {
  //       filename: file.name,
  //       contentType: file.mimetype,
  //   });

  // this.axios.post("/ccb/auth/fe/optColorLabel/fromCsvOpt", formData ,  this.authHeader)

     // this.axios
      //  .post('/ccb/auth/fe/packConf/importCommercialPacks', {uploadImportCommPackResult:this.uploadCsvJSON},  this.authHeader)

    // this.axios
      //   .get('/ccb/auth/fe/user/dbadm', this.authHeader)
      //   .then(response => this.axios
      //     .put('/ccb/auth/fe/user/test', {username: "test", password: "asd", active:true, mktg:true, ccadmEnabled:true, 
      //       priceConfEnabled:true, packConfEnabled:true, apiUser:true},this.authHeader)
      //     .then(response => this.axios
      //       .get('/ccb/auth/fe/user/test', this.authHeader)
      //       .then(response => this.axios
      //         .delete('/ccb/auth/fe/user/test', this.authHeader)
      //         .then(response => this.axios
      //           .get('/ccb/auth/fe/user/dbadm', this.authHeader)
      //           .then(response => alert(response.data.username)
      //           )
      //         )
      //       )
      //     )
      //   )
      //test CORS
      /*this.axios
        .get('http://localhost/ccb/public/api/countryModel/list', this.authHeader)
        .then(response => alert(response.data.length)
        )*/
    },
    refreshTable() {
      this.search();
    },
    initLabelGroupList(){      
      var menSrc = this.getMenuList;
      this.setLabelGroupList(menSrc.submenuList);
    },
    ...mapActions([
      'setCurApp',
      'setSpinnerStatus',
      'setLastSearch',
      'setInterfaceLabels',
      'setCurLabelGroup',
      'setLabelGroupList'
      
    ]),
    loadLabelGroups() {
      this.axios
        .get('/ccb/auth/fe/interfaceLabel/labelGroups', this.authHeader)
        .then(response => {
          this.labelGroupList = response.data;
        });
    }
  },
  data () {
    return {
      urlExport:' ',
     totalRowsResult: 0,
      routerParams: null,
      currentPage:1,
      perPage:10,
      sortBy:'code',
      sortDesc: false,
      curItem: null,
      newItem : {id:null, language: null, labelGroup: null, code : null, label: null, modelEnableRegexp: 'DEFAULT', modelDisableRegexp: null, scope:null, languageToExport:[]},
      exportFiltered: true,
      selectedLanguagesToExport: [],
      fields: [
        {
          key: 'code',
          label: 'Code'
        },
        {
          key: 'label',
          label: 'Label'
        },
        {
          key: 'modelEnableRegexp',
          label: 'Model Enabled (regexp)',
          sortable: false
        },
        {
          key: 'modelDisableRegexp',
          label: 'Model Disabled (regexp)',
          sortable: false
        },
        {
          key: 'labelGroup',
          label: 'Label Group',
          sortable: false
        },
        {
          key: 'buttons',
          label: ''
        }
      ],
      labelFilter: '',
      codeFilter: '',
      labelGroupFilter: null,
      labelGroupList: [],
      fileName: ''
    }
  },
  computed: {
    languageOptions(){
      return [{ value: 'ALL', text: 'ALL' }].concat(this.languages);
    },
    items () {
      return (this.getInterfaceLabels && this.getInterfaceLabels.length) ? this.getInterfaceLabels : [];
    },
    ...mapState([
      'curLanguage',
      'curModel',
      'languages',
      'models'
    ]),
    ...mapGetters([
      'getCurModel7DigitsCode',
      'getLanguageLabel',
      'authHeader',
      'uploadCsvJSON',
      'getInterfaceLabels',
      'getLabelGroupList',
      'getCurLabelGroup',
      'getCurLanguage',
      'getCurLanguageObj',
      'getCurModel',
      'getMenuList'
    ])
  },
   watch: {
     $route (to,from){
       this.routerParams = to;
       if(to.query.activeGroup && to.query.activeGroup !=null){
          this.setCurLabelGroup(to.query.activeGroup);        
        }
       if(to.query.action && to.query.action === 'search'){
        this.search();        
       }
     },   
    items (oldValue, newValue) {
      //console.log(this.$refs)
      //this.$refs.interface_labels_tab.refresh();
    },
   currentPage(newValue,oldValue){
      this.refreshTable();
    },
    perPage(newValue,oldValue){
      this.refreshTable();
    },
    sortBy(newValue,oldValue){
      this.refreshTable();
    },
    sortDesc(newValue,oldValue){
      this.refreshTable();
    }
  },
  updated(){
  },
  mounted() { 
    window.scoper = this


    var scope = this;
        

    if(this.$route.query.activeGroup && this.$route.query.activeGroup !=null){
          this.setCurLabelGroup(this.$route.query.activeGroup);        
        }
       if(this.$route.query.action && this.$route.query.action === 'search'){
         //alert('search')
        this.search();        
       }
    this.setCurApp('ccadm');
    this.loadLabelGroups();
  },
  created() {
    this.newItem.languageToExport = [this.getCurLanguage];
    this.selectedLanguagesToExport = this.languages.filter(lg => lg.value == this.getCurLanguage);
  }
  
}
</script>

<style scoped lang="scss">
@import "../../assets/scss/_variables.scss";
.collapse {
  border: 1px solid $gray-lightest;
  border-radius: 0.25rem;
}

.export-modal-body {
  padding: 24px;
}

.export-section {
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 16px;
  margin-bottom: 18px;
  background: #fafafa;
}

.export-section-title {
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 4px;
}

.export-section-subtitle {
  font-size: 12px;
  color: #6b7280;
  margin-bottom: 12px;
}

.export-language-select {
  min-height: 140px;
}

.export-checkbox-box {
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 16px;
  background: #fafafa;
}

.checkbox-subtitle {
  margin-top: 6px;
  margin-left: 24px;
  margin-bottom: 0;
}

::v-deep .modal-dialog {
  max-width: 850px;
}
</style>
